/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BoneTag,
  CreateBoneTag,
} from '../models/index';
import {
    BoneTagFromJSON,
    BoneTagToJSON,
    CreateBoneTagFromJSON,
    CreateBoneTagToJSON,
} from '../models/index';

export interface BoneTagCreateRequest {
    createBoneTag: CreateBoneTag;
}

export interface BoneTagDeleteRequest {
    tagId: string;
}

export interface BoneTagUpdateRequest {
    boneTag: BoneTag;
}

/**
 * 
 */
export class BoneTagApi extends runtime.BaseAPI {

    /**
     */
    async boneTagCreateRaw(requestParameters: BoneTagCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BoneTag>> {
        if (requestParameters['createBoneTag'] == null) {
            throw new runtime.RequiredError(
                'createBoneTag',
                'Required parameter "createBoneTag" was null or undefined when calling boneTagCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/bone-tag/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBoneTagToJSON(requestParameters['createBoneTag']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BoneTagFromJSON(jsonValue));
    }

    /**
     */
    async boneTagCreate(requestParameters: BoneTagCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BoneTag> {
        const response = await this.boneTagCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async boneTagDeleteRaw(requestParameters: BoneTagDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tagId'] == null) {
            throw new runtime.RequiredError(
                'tagId',
                'Required parameter "tagId" was null or undefined when calling boneTagDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bone-tag/{tagId}`.replace(`{${"tagId"}}`, encodeURIComponent(String(requestParameters['tagId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async boneTagDelete(requestParameters: BoneTagDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.boneTagDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async boneTagListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BoneTag>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bone-tag`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BoneTagFromJSON));
    }

    /**
     */
    async boneTagList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BoneTag>> {
        const response = await this.boneTagListRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async boneTagUpdateRaw(requestParameters: BoneTagUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BoneTag>> {
        if (requestParameters['boneTag'] == null) {
            throw new runtime.RequiredError(
                'boneTag',
                'Required parameter "boneTag" was null or undefined when calling boneTagUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/bone-tag/update`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BoneTagToJSON(requestParameters['boneTag']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BoneTagFromJSON(jsonValue));
    }

    /**
     */
    async boneTagUpdate(requestParameters: BoneTagUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BoneTag> {
        const response = await this.boneTagUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
